import { GroupOperator } from './types'

interface SegmentFilterSeparatorProps {
  operator: GroupOperator
}

const SegmentFilterSeparator = ({ operator }: SegmentFilterSeparatorProps) => {
  // NOTE: Architecture alignment - Display operator as separator between filters
  // This may need to be updated if operator representation changes
  return (
    <div className="thanx-ai-segment-visualization__filter-separator">
      {operator}
    </div>
  )
}

export default SegmentFilterSeparator
